import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { logoutAsync } from '../AuthSlice'
import { useNavigate } from 'react-router-dom'

export const Logout = () => {
    const dispatch=useDispatch()
    const navigate=useNavigate()

  useEffect(()=>{
    let mounted = true
    const doLogout = async () => {
      try {
        await dispatch(logoutAsync()).unwrap()
      } catch (err) {
        console.error('Logout error', err)
      } finally {
        if (mounted) navigate('/login')
      }
    }
    doLogout()

    return ()=>{ mounted = false }
  },[dispatch, navigate])

  return (
    <></>
  )
}
